import React from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { maximizeIncomingCall } from 'store/actions/call'

export default function MinimizedCalls({ call, minimizedCallsQty }) {
    const { number, displayName } = call
    const { t } = useTranslation()
    const dispatch = useDispatch()
    const showDisplayName = minimizedCallsQty < 2
    const showTitle = showDisplayName

    const onMaximize = () => {
        dispatch(maximizeIncomingCall({ number }))
    }

    return (
        <>
            <button className="call__minimized__item" onClick={onMaximize}>
                {showTitle && <h6 className="call__minimized__item--title">{t('inbound_call')}</h6>}
                <div className="call__minimized__item--details">
                    {showDisplayName && <span className="call__minimized__item--display-name">{displayName}</span>}
                    <span className="call__minimized__item--number">{number}</span>
                </div>
            </button>
        </>
    )
}
